import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

type AuthWrapperProps = {
  children: ReactNode | ReactNode[];
};

const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_APP_AUTH0_DOMAIN ?? ''}
      clientId={import.meta.env.VITE_APP_AUTH0_CLIENT_ID ?? ''}
      authorizationParams={{
        audience: import.meta.env.VITE_APP_AUTH0_API_AUDIENCE ?? '',
        redirect_uri: window.location.origin,
      }}
      useRefreshTokens={import.meta.env.DEV}
      cacheLocation={import.meta.env.DEV ? 'localstorage' : 'memory'}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthWrapper;
